<template>
    <div>
        <div class="m-content">
            <p v-if="message.content.forwarded"
               class="text-sm pb-2">
                {{ $t('forwarded_message') }}
            </p>

            {{ message.content.text }}


            <div v-if="message.content.context"
                 class="rounded p-2"
                 :class="{'context': message.content.context}">

                <hr>

                <component
                        v-if="componentsMap[message.content.context.quoted_message.content_type]"
                        v-bind:is="componentsMap[message.content.context.quoted_message.content_type]"
                        :message="message.content.context.quoted_message" :instance-id="instanceId"></component>

                <component v-else v-bind:is="componentsMap['UNKNOWN']"
                           :instance-id="instanceId"
                           :message="message.content.context.quoted_message"></component>
            </div>
        </div>
    </div>
</template>

<style>
    .forwarded {
        color: darkgrey;
    }

    .context {

    }
</style>

<script>
    export default {
        props: {
            message: Object,
            instanceId: String
        },

        data() {
            return {
                componentsMap: this.$parent.componentsMap,
                quoted: null
            }
        },

        mounted() {
            if(this.message.content.context) {
                this.message.content.context.quoted_message.id = this.message.id;
                this.message.content.context.quoted_message.quoted = true;
                this.message.content.context.quoted_message.from_me = this.message.from_me;

                // this.$set(this.message.content.context.quoted_message, 'id', this.message.id);
                // this.$set(this.message.content.context.quoted_message, 'quoted', true);
                // this.$set(this.message.content.context.quoted_message, 'from_me', this.message.from_me);
            }
        },

        methods: {
            alert(message) {
                this.$parent.alert(message);
            }
        }
    }
</script>
